// Auto-generated — Culture Antique signature antique-gold product panels.
const panels = [
  { src: "/assets/collection/panel-001.jpg", w: 552, h: 1400 },
  { src: "/assets/collection/panel-002.jpg", w: 552, h: 1400 },
  { src: "/assets/collection/panel-003.jpg", w: 552, h: 1400 },
  { src: "/assets/collection/panel-004.jpg", w: 552, h: 1400 },
  { src: "/assets/collection/panel-005.jpg", w: 552, h: 1400 },
  { src: "/assets/collection/panel-006.jpg", w: 552, h: 1400 },
  { src: "/assets/collection/panel-007.jpg", w: 552, h: 1400 },
  { src: "/assets/collection/panel-008.jpg", w: 552, h: 1400 },
  { src: "/assets/collection/panel-009.jpg", w: 552, h: 1400 },
];

export default panels;
